import { Box, Typography } from '@mui/material';
import {
  minutesToTime,
  isBusinessMinute,
  CLASSIC_SLOT_HEIGHT,
  SLOT_MINUTES,
} from '../utils/scheduleUtils';

const LABEL_FONT_SIZE_PX = 11;
const RULER_WIDTH_PX = 60;

// Shared with the corner cell, which sits in another row of the board: the two must be exactly
// as wide for the day headers to stay over their columns.
const rulerFrameSx = {
  flexShrink: 0,
  position: 'sticky',
  left: 0,
  // Above the day columns' "now" line (3): `position: sticky` opens a stacking context here, so
  // anything inside is capped at this level, and a tie would be decided by DOM order — which the
  // later columns win.
  zIndex: 5,
  borderRight: '1px solid #e0e0e0',
};

/** The ruler's cell in the board's header row (see ScheduleScroller). */
export const TimeRulerCorner = () => (
  <Box sx={{ ...rulerFrameSx, bgcolor: '#1a1a1a' }}>
    <Box sx={{ width: RULER_WIDTH_PX }} />
  </Box>
);

/**
 * The fixed left column of the classic board. It shares CLASSIC_SLOT_HEIGHT with
 * DailyScheduleCard so a label sits exactly on its gridline, spans the same window as the
 * columns, and greys the marks outside the tenant's opening hours.
 */
export const TimeRuler = ({ gridWindow }) => {
  const marks = Array.from({ length: gridWindow.slotCount + 1 }, (_, i) => {
    const minutes = gridWindow.start + i * SLOT_MINUTES;
    const isWholeHour = minutes % 60 === 0;
    const inBusiness = isBusinessMinute(gridWindow, minutes);

    return (
      <Box
        key={minutes}
        sx={{
          position: 'absolute',
          top: i * CLASSIC_SLOT_HEIGHT,
          right: 8,
          transform: i === 0 ? 'none' : 'translateY(-50%)',
        }}
      >
        <Typography
          sx={{
            fontSize: LABEL_FONT_SIZE_PX,
            fontWeight: inBusiness && isWholeHour ? 600 : 400,
            color: inBusiness ? (isWholeHour ? '#555' : '#999') : '#ccc',
            lineHeight: 1,
            whiteSpace: 'nowrap',
            fontVariantNumeric: 'tabular-nums',
          }}
        >
          {minutesToTime(minutes)}
        </Typography>
      </Box>
    );
  });

  return (
    <Box sx={{ ...rulerFrameSx, bgcolor: '#fff' }}>
      <Box
        sx={{
          position: 'relative',
          width: RULER_WIDTH_PX,
          height: gridWindow.slotCount * CLASSIC_SLOT_HEIGHT,
          bgcolor: '#fff',
        }}
      >
        {marks}
      </Box>
    </Box>
  );
};

export default TimeRuler;
